import { render, staticRenderFns } from "./EditGenerallyObjects.vue?vue&type=template&id=1dd545b7&scoped=true"
import script from "./EditGenerallyObjects.vue?vue&type=script&lang=js"
export * from "./EditGenerallyObjects.vue?vue&type=script&lang=js"
import style0 from "./EditGenerallyObjects.vue?vue&type=style&index=0&id=1dd545b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd545b7",
  null
  
)

export default component.exports